import { createSlice } from "@reduxjs/toolkit";
import { editUser, getAllUsers } from "./userService";

const initialState = {
    allUsers: {
        isUsersLoading: null,
        isUsersSuccess: null,
        allusersMesssage: null,
        pageCount: 0,
        users: []
    },

    editUser: {
        isEditingUser: null,
        isUserEdited: null,
        userEditedMsg: null
    },
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllUsers.pending, (state) => {
                console.log('pending', state)
                state.allUsers = {
                    ...initialState.allUsers,
                    isUsersLoading: true,
                }
            })

            .addCase(getAllUsers.rejected, (state, action) => {
                console.log('rejected', action);
                state.allUsers = {
                    ...initialState.allUsers,
                    isUsersLoading: false,
                    isUsersSuccess: false,
                    allusersMesssage: action.payload.message || 'Error'
                }
            })

            .addCase(getAllUsers.fulfilled, (state, action) => {
                console.log('fulfilled', action);
                state.allUsers = {
                    ...initialState.allUsers,
                    isUsersLoading: false,
                    isUsersSuccess: true,
                    allusersMesssage: 'Success',
                    pageCount: action.payload.pageCount,
                    users: action.payload.data || []
                }
            });


        //User editing
        builder
            .addCase(editUser.pending, (state) => {
                state.editUser = {
                    ...initialState.editUser,
                    isEditingUser: true,
                    userEditedMsg: 'Loading',
                };
            })

            .addCase(editUser.rejected, (state, action) => {
                state.editUser = {
                    ...initialState.editUser,
                    isEditingUser: false,
                    isUserEdited: false,
                    userEditedMsg: action.payload || 'Error occurred while editing the user.',
                };
            })

            .addCase(editUser.fulfilled, (state, action) => {
                state.editUser = {
                    ...initialState.editUser,
                    isEditingUser: false,
                    isUserEdited: true,
                    userEditedMsg: action.payload || 'Successfully edited the user.',
                };
            });
    }
});

export default userSlice.reducer;